
<template>
  <div class="tf-vue-bg-grey-darker">
    <a href="javascript:void(0)" class="text-white text-decoration-none d-flex align-items-center justify-content-center w-100 h-100 p-2" data-bs-toggle="modal" data-bs-target="#discountModal">
      <!-- fix class above for tf express '?' styling -->
      <i class="icon-information"></i>
      <span class="glyphicon glyphicon-question-sign"></span>
    </a>
    <div 
      id="discountModal" 
      class="modal"
      tabindex="-1"
      aria-labelledby="discountModalLabel"
      aria-hidden="true" 
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content p-4">
          <div class="container">
        <div class="mb-3 row">
          <div class="col-12">
            <h4 class="text-center text-dark">25% discount</h4>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p class="text-dark fw-bold">
             I wish to receive a 25% discount off my Premium and confirm my Private Health Insurance 
             provides medical expenses cover overseas. Such Health Insurance will remain in force for 
             the duration of thisinsurance.
            </p>
          </div>
        </div>
      </div>

      <div class="text-center my-5">
        <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Cancel</button>
      </div>
        </div>
      </div> 
    </div>
  </div>
</template>


<script>
export default {
  props: ['quoteType'],
  data() {
    return {
      modalShow:false,
    }
  },
  computed: {
    title() {
      if(this.quoteType === 'SINGLEG') {
        return 'Single Trip Insurance'
      } else {
        return 'Annual Multi-Trip'
      }
    },
  },
  methods: {
    hideModal() {
      this.modalShow = false
    },
  }
}
</script>
<style scoped>
</style>